export function validateFileExtension(
  file: File,
  allowedExtensions: string[]
): boolean {
  const extension = file.name.split(".").pop().toLowerCase();
  return allowedExtensions.includes(extension);
}
